import React from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { handleLogout } from '../utils/constant';
import { getUserCurrencyFromLocalStorage, getUserIdFromLocalStorage } from '../utils/helper';
import { getSupplierDataByUserId } from '../utils/actions/userActions';
import { useEffect } from 'react';

const PrivateRoute = () => {
    let isLoggedIn = localStorage.getItem('isLoggedIn');
    let token = localStorage.getItem('Token');
    const location = useLocation();
    let auth;


    useEffect(() => {
        (async () => {
            try {
                const id = getUserIdFromLocalStorage();
                const isCurrencyExists = getUserCurrencyFromLocalStorage();
                if (!isCurrencyExists && id) {
                    //fetch currency details
                    const res = await getSupplierDataByUserId(id);
                    if (res.success) {
                        const { data } = res;
                        const { currency } = data;
                        const currencyMeta = {
                            code: currency,
                            precision: 2,
                        }
                        localStorage.setItem('currency_meta', JSON.stringify(currencyMeta));
                    }
                }

            } catch (error) {
                console.error('Failed to load user currency');
            }
        })();

    }, []);


    if ((token == null || token == '') && (isLoggedIn == null || isLoggedIn == '')) {
        auth = false;
    }
    else if (isLoggedIn && token !== null) {
        let decode = jwt_decode(token);
        if (!decode) {
            auth = false;
        }
        else if (decode.exp * 1000 < Date.now()) {
            auth = false;
        }
        else if (decode.userType == 'user') {
            auth = true;
        }
        else {
            auth = false;
        }
    }
    else if (isLoggedIn && (token == null || token == '')) {
        auth = false;
    }
    else {
        auth = false
    }
    console.log("Auth ::", auth);
    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    if (auth) {
        return <Outlet />;
    }
    handleLogout();
    return <Navigate to="/" replace={true} state={{ pathAfterLogin: location }} />
}

export default PrivateRoute;